<template>
    <b-overlay :show="loading" opacity="1">
        <table class="table table-bordered table-sm header-bordered">
            <thead>
                <tr>
                    <th>Arabulucuk Yapıldı Mı?</th>
                    <th>Anlaşma Sağlandı Mı?</th>
                    <th>Ödeme Tarihi</th>
                    <th>Ödeme Miktarı</th>
                    <th>Açıklama</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-center">
                        <span class="material-icons-outlined text-success d-block" v-if="mediation != null">check_circle</span>
                        <span class="material-icons-outlined text-danger d-block" v-else>cancel</span>
                    </td>
                    <td class="text-center">
                        <span class="material-icons-outlined text-success d-block" v-if="$safe(mediation,'Agreed') == true">check_circle</span>
                        <span class="material-icons-outlined text-danger d-block" v-else-if="$safe(mediation,'Agreed') == false">cancel</span>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="$safe(mediation,'PaymentDeadline')">{{$safe(mediation,'PaymentDeadlineStr')}}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="$safe(mediation,'PaymentAmount')">{{$safe(mediation,'PaymentAmountStr')}}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="$safe(mediation,'Description')">{{$safe(mediation,'Description')}}</template>
                        <template v-else>-</template>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-1">
            <tbody>
                <tr><th colspan="2" class="bg-light-secondary text-center">HAKEDİŞ ÖN İNCELEME TABLOSU</th></tr>
                <tr>
                    <th class="w-50 bg-light">AD-SOYAD</th>
                    <td class="w-50">{{$safe(progressData,'FullName') || '-'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">ŞUBE</th>
                    <td class="w-50">{{$safe(progressData,'Branch') || '-'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">GÖREVİ</th>
                    <td class="w-50">{{$safe(progressData,'Title') || '-'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">GİRİŞ TARİHİ</th>
                    <td class="w-50">{{$safe(progressData,'EntryDate') || '-'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">İŞTEN ÇIKIŞ TARİHİ</th>
                    <td class="w-50">{{$safe(progressData,'ExitDate') || '-'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">İŞTEN ÇIKIŞ SEBEBİ</th>
                    <td class="w-50">{{$safe(progressData,'ExitCause') || '-'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">KIDEMİ</th>
                    <td class="w-50">{{$safe(progressData,'Seniority') || '-'}}</td>
                </tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-1">
            <tbody>
                <tr>
                    <th class="w-50 bg-light">{{exitDateSallary}}</th>
                    <td class="w-50">{{$safe(progressData,'Salary') || '0'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">YILLIK İZİN (İŞ GÜNÜ)</th>
                    <td class="w-50">{{$safe(progressData,'AnnualHolidayGain') || '0'}}</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">KIDEM TAZMİNATI</th>
                    <td class="w-50">**</td>
                </tr>
                <tr>
                    <th class="w-50 bg-light">İHBAR TAZMİNATI</th>
                    <td class="w-50">**</td>
                </tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-1">
            <tbody>
                <tr><th colspan="2" class="bg-light-secondary text-center">İCRASI</th></tr>
                <tr><td colspan="2">{{$safe(progressData,'TotalRemainingLevyAmount') || '0'}}</td></tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-1">
            <tbody>
                <tr><th colspan="2" class="bg-light-secondary text-center">İHTARNAME/ARABULUCU DAVETİ</th></tr>
                <tr><td colspan="2">**</td></tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-1">
            <tbody>
                <tr><th colspan="2" class="bg-light-secondary text-center">CARİ KAYDI</th></tr>
                <tr><td colspan="2">**</td></tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-1">
            <tbody>
                <tr><th colspan="2" class="bg-light-secondary text-center">CEZA KAYDI</th></tr>
                <tr><td colspan="2">{{$safe(progressData,'TotalFine') || '0'}}</td></tr>
            </tbody>
        </table>
        <table class="table table-sm table-bordered mb-0">
            <tbody>
                <tr><th colspan="2" class="bg-light-secondary text-center">KAZA/HASAR KAYDI</th></tr>
                <tr><td colspan="2">{{$safe(progressData,'TotalCrash') || '0'}}</td></tr>
            </tbody>
        </table>
    </b-overlay>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import  {BOverlay} from 'bootstrap-vue'
import moment from 'moment'

export default {
    components:{
        BOverlay
    },
    props:{
        value:Object
    },
    data(){
        return {
            progressData:{},
            mediation:{},
            loading:false
        }
    },
    mounted(){
        this.getAll()
    },
    methods:{
        getAll(){
            this.loading = true
            Promise.all([this.getProcessPaymentTable(),this.getMediation()]).then(()=>{
                this.loading = false
            })
        },
        getProcessPaymentTable(){
            return new Promise((resolve,reject)=>{
                if(this.value.SgkJobNoticeId){
                    EmployeeOperationsApi.Employee.SGK.GetProcessPaymentTable(this.value.SgkJobNoticeId).then(res=>{
                        if(res.data.Success){
                            this.progressData = res.data.Data
                            resolve()
                        }else {
                            this.$result(res)
                            reject()
                        }
                    })
                }
            }).catch(err=>{
                this.$result(null,err)
                reject()
            })
        },
        getMediation(){
            return new Promise((resolve,reject)=>{
                if(this.value.SgkJobNoticeId){
                    EmployeeOperationsApi.Employee.SGK.GetMediation(this.value.SgkJobNoticeId).then(res=>{
                        if(res.data.Success){
                            this.mediation = res.data.Data
                            resolve()
                        }else {
                            this.$result(res)
                            reject()
                        }
                    })
                }
            }).catch(()=>{
                this.$result(null,err)
                reject()
            })
        }
    },
    computed:{
        exitDateSallary(){
            return this.progressData?.ExitDate ? moment(this.progressData.ExitDate,'DD.MM.YYYY').format('MM/YYYY') : '--/----'
        }
    }
}
</script>

<style>

</style>